import { PermissionKind, ProctoringDisconnectReason } from 'Components/Proctoring/proctoring.types'
import type { PermissionDef } from 'Components/Proctoring/proctoring.types'
import type { DeviceRecoveryFailureReason } from 'proctoring-sdk/index'

export const PRIVACY_POLICY_URL =
    'https://www.telusinternational.com/privacy-policy/contributors?INTCMP=ti_privacypolicy_lin[…]data-annotation-solutions-community-data-privacy-notice'

export const GDPR_URL = 'https://gdpr.eu/'

export const INVALID_SCREEN_SHARE_PREFIX = 'INVALID_SCREEN_SHARE'
export const MULTIPLE_MONITORS_PREFIX = 'MULTIPLE_MONITORS_DETECTED'

export const PROCTORING_ERROR_MESSAGES = {
    PERMISSION:
        'All required permissions are needed. Enable them in your browser settings to continue.',
    SCREEN_SHARE_INVALID:
        'Select "Entire Screen" when sharing. Window or tab sharing isn’t allowed.',
    SCREEN_SHARE_STOPPED:
        'Screen sharing stopped. Share your entire screen again to continue the task.',
    WEBCAM_DISCONNECTED: 'Webcam disconnected. Re-enable camera access to continue the task.',
    MULTIPLE_MONITORS:
        'Looks like more than one display is connected. Please disconnect any additional displays to continue.',
} as const

export const DEVICE_FAILURE_HINTS: Record<DeviceRecoveryFailureReason, string> = {
    permission_denied:
        "Your browser is blocking access. Allow it in your browser's site settings, then try again.",
    device_unavailable: "We still can't detect the device. Please make sure it's connected.",
}

export const SCREEN_SHARE_FAILURE_HINTS: Record<DeviceRecoveryFailureReason, string> = {
    permission_denied:
        'Screen sharing was cancelled or blocked. Click Screen Share and allow access to your entire screen.',
    device_unavailable:
        "We couldn't start screen sharing. Click Screen Share and choose your entire screen.",
}

export const DISCONNECT_REASON_MESSAGES: Record<string, string> = {
    [ProctoringDisconnectReason.WebcamDisconnected]: PROCTORING_ERROR_MESSAGES.WEBCAM_DISCONNECTED,
    [ProctoringDisconnectReason.ScreenShareStopped]: PROCTORING_ERROR_MESSAGES.SCREEN_SHARE_STOPPED,
}

export const PERMISSION_DEFS: PermissionDef[] = [
    { kind: PermissionKind.Webcam, label: 'Webcam Access', hideAvailableDevices: false },
    { kind: PermissionKind.Microphone, label: 'Microphone Access', hideAvailableDevices: false },
    {
        kind: PermissionKind.Screen,
        label: 'Full-screen Sharing Access',
        hideAvailableDevices: true,
    },
]
